module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-TIR_1.b70c7673.jpg";